<ion-app>
  <ion-menu contentId="main-content">
    <ion-header class="pointer" >
      <ion-toolbar color=primary *ngIf="user" [routerLink]="['/perfil']">
        <ion-menu-toggle>
          <ion-grid>
            <ion-row class="menu-row">
              <ion-col size="3">
                <ion-avatar class="avatar-wraper">
                  <ion-img [src]="user.profileImage" *ngIf="user.profileImage"></ion-img>
                  <div *ngIf="!user.profileImage">
                    <ion-img class="icon-beneficiario" [src]="'/assets/imgs/icons/beneficiario.svg'"></ion-img>
                  </div>
                </ion-avatar>
              </ion-col>
              <ion-col size="9" class="ion-no-padding" *ngIf="user">
                <h4><b>{{ user.name | titlecase}} {{ user.surname  | titlecase}}</b></h4>
                <h5 class="no-margin" *ngIf="user.name">{{ user.email }}</h5>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-menu-toggle>
      </ion-toolbar>
    </ion-header>

    <ion-content>

      <ion-list lines="none" *ngIf="user">

        <!-- Menu items -->
        <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
          <ion-item [routerDirection]="'root'" [routerLink]="[p.url]" *ngIf="validateMenu(p)" class="side-menu-item">
            <ion-col size="4">
              <img src={{p.icon}}>
            </ion-col>
            <ion-col size="8">
              <h4 class="secondary-text">{{ p.title }}</h4>
            </ion-col>
          </ion-item>
        </ion-menu-toggle>

        <!-- Admin -->
        <ion-menu-toggle *ngIf="user && user.admin && user.admin.state === 'active'">
          <ion-item button="true" class="side-menu-item" [routerLink]="['/admin']">
            <ion-col size="4">
              <img src="/assets/imgs/icons/confirmacion.svg">
            </ion-col>
            <ion-col size="8">
              <h4 class="secondary-text">Administrador</h4>
            </ion-col>
          </ion-item>
        </ion-menu-toggle>

        <!-- Mediamigos -->
        <ion-menu-toggle *ngIf="isMedifriend()">
          <ion-item button="true" class="side-menu-item" [routerLink]="['/mediamigos/tramites']">
            <ion-col size="4">
              <img src="/assets/imgs/icons/beneficiario-creado.svg">
            </ion-col>
            <ion-col size="8">
              <h4 class="secondary-text">Mediamigos</h4>
            </ion-col>
          </ion-item>
        </ion-menu-toggle>

        <!-- Ventas Telemedicina -->
        <ion-menu-toggle *ngIf="isSeller()">
          <ion-item button="true" class="side-menu-item" [routerLink]="['/ventas-telemedicina']">
            <ion-col size="4">
              <img src="/assets/imgs/icons/coupon-primary.svg">
            </ion-col>
            <ion-col size="8">
              <h4 class="secondary-text">Mis ventas</h4>
            </ion-col>
          </ion-item>
        </ion-menu-toggle>

      </ion-list>
    </ion-content>

    <ion-footer>
      <ion-toolbar>

        <ion-row>
          <!-- T&C -->
          <ion-col class="ion-text-center">
            <h4>
              <a class="secondary-text pointer" (click)="openLink(environment.wsChat+'?text=Requiero%20soporte', 'supportLead')">
                <b>Servicio al Cliente</b>
              </a>
            </h4>
            <h5>
              <a class="secondary-text pointer" (click)="openLink(environment.politicasLink, 'viewLegalPoliticas')">
                Políticas de privacidad
              </a>
            </h5>
            <h5>
              <a class="secondary-text" (click)="openLink(environment.terminosLink, 'viewLegalTerminos')">
                Términos y condiciones              
              </a>
            </h5>
            <ion-menu-toggle>
              <h5>
                <a class="danger-text pointer" (click)="helperService.logout()">
                  Cerrar Sesión             
                </a>
              </h5>
            </ion-menu-toggle>
            <h6 class="ion-text-center primary-text version">{{ appVersion }}</h6>
          </ion-col>

        </ion-row>

      </ion-toolbar>
    </ion-footer>
  
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>